exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btns[data-v-f624defa]{padding-top:20px;border-top:1px solid #eee}.btns .btn[data-v-f624defa]{width:100%;height:60px;font-size:18px;font-weight:500;background:#009406;color:#fff}\n", ""]);

// exports
